/**
 * Created by Ning Jiang on 2022-03-08.
 */

import {SerialSymbolState} from "./SerialSymbolConfig";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Serial} from "../Serial";
import {SerialGameAssets} from "../SerialGameAssets";
import {SerialSound} from "../sound/SerialSound";
import {MaskedSymbol} from "./MaskedSymbol";

export class XWaysSymbol extends MaskedSymbol {

    private _landingSprite:TimelineSprite;
    private _fromScatter:PIXI.spine.Spine;

    constructor(symbolName:string, reelId:number, symbolHeight:number, initState:SerialSymbolState) {
        super(symbolName, reelId, symbolHeight, initState);
        this._multiplierFont = SerialGameAssets.BITMAP_FONT_SCATTER;
        this._multiplierLetterSpacing = -15;
        this.blockReelLandingSound = true;
    }

    public playLanding():gsap.core.Animation {
        if(!this._landingSprite) {
            this._landingSprite = new TimelineSprite(Serial.assetLoader.getTextures("xways/XWaysLand/XWaysLand_"));
            this._landingSprite.anchor.set(0.5);
            this._landingSprite.hide();
        }
        const tl = gsap.timeline();
        tl.add(() => {
            this.addChild(this._landingSprite);
            this.updateLayers();
            SerialSound.soundPlayer.playTrack({name : SerialSound.XWAYS_LANDING});
        });
        tl.add(<gsap.core.Timeline><unknown>this._landingSprite.getAnimationAutoShowHide());
        tl.add(() => {this.removeChild(this._landingSprite)})
        return tl;
    }

    public playFromScatter():TimelineLite {
        if(!this._fromScatter) {
            this._fromScatter = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("S1ToXways"));
            this._fromScatter.autoUpdate = true;
            this._fromScatter.position.set(this._centerPosition.x, this._animation.y);
            this.addChild(this._fromScatter);
        }
        const tl = gsap.timeline();
        tl.add(() => {this._fromScatter.state.setAnimation(0, "animation", false)});
        tl.add(() => {
                this.removeChild(this._fromScatter);
                this._fromScatter.destroy();
            },
            this._fromScatter.spineData.findAnimation("animation").duration);
        tl.add(gsap.to(this, {duration : 0.5}));
        return tl;
    }

    public showMultiplier(text:string):gsap.core.Animation {
        const ani = super.showMultiplier(text);
        this._multiplierContainer.position.set(18, 22);
        return ani;
    }
}